import React from "react"
import { appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useConditional } from "lib/units/conditional"

export default function ConditionalTestingArea({ className="" }:{ className?:string }){

  const { store }:any = appStore()
  const { conditionalState, conditionalTools }:any = useConditional()

  // const titleClasses = 
  //   "text-xs absolute top-[-9px] pl-1 pr-3 bg-slate-900 uppercase",
  //   store.location.mode === "remote" && "relative left-0 py-1 mb-2 bg-transparent border border-solid border-slate-800"
  // )

  return (
    <div className={cn(className, "pb-3")}>
      {/* <div className={cn(titleClasses, "left-[10px]")}>mock api area</div> */}
      {/* <StatementBuilder /> */}
    </div>
  )
}